/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Mk_Sol_Ukm_O1Inputs */

const en_mk_sol_ukm_o1 = /** @type {(inputs: Mk_Sol_Ukm_O1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`The first hour of every morning goes back to running the branches`)
};

const id_mk_sol_ukm_o1 = /** @type {(inputs: Mk_Sol_Ukm_O1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Jam pertama tiap pagi kembali untuk mengurus cabang`)
};

/**
* | output |
* | --- |
* | "The first hour of every morning goes back to running the branches" |
*
* @param {Mk_Sol_Ukm_O1Inputs} inputs
* @param {{ locale?: "en" | "id" }} options
* @returns {LocalizedString}
*/
export const mk_sol_ukm_o1 = /** @type {((inputs?: Mk_Sol_Ukm_O1Inputs, options?: { locale?: "en" | "id" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Mk_Sol_Ukm_O1Inputs, { locale?: "en" | "id" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "id") return id_mk_sol_ukm_o1(inputs)
	return en_mk_sol_ukm_o1(inputs)
});